import { SupplierRegistrationCountryFields } from '@supplierRegistration/domain/supplierRegistrationCountryFields';

enum FranceLegalIdTypesForCompany {
  SIRET = 'SIRET',
  VAT = 'VAT',
  Other = 'Other',
}

export const FR: SupplierRegistrationCountryFields = {
  leis: { types: FranceLegalIdTypesForCompany },
};
